import { render, staticRenderFns } from "./RirekishoPreview.vue?vue&type=template&id=2da95dda"
import script from "./RirekishoPreview.vue?vue&type=script&lang=js"
export * from "./RirekishoPreview.vue?vue&type=script&lang=js"
import style0 from "./RirekishoPreview.vue?vue&type=style&index=0&id=2da95dda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports